/* global gon */

import { call, put, select } from 'redux-saga/effects'
import { filterTokens, tokenize } from '../reducers/publisher_reducer_methods'

import { updateTags,
  updateName,
  updateDescription,
  updateConstraints,
  updateFeatures,
  constraintsFetchFailed,
} from '../actions/form_slice_actions'
import { stripHTMLFromString } from '../helpers'

export const constraintsFetchSucceeded = (changes) => {
  const payload = changes.payload || {}
  if (typeof payload.features !== 'undefined') {
    return updateFeatures({
      constraints: changes.constraints,
      errors: payload.errors,
      features: payload.features,
      constraintsPending: false })
  }

  if (typeof payload.description !== 'undefined') {
    return updateDescription({
      constraints: changes.constraints,
      errors: payload.errors,
      description: payload.description,
      constraintsPending: false })
  }

  if (typeof payload.name !== 'undefined') {
    return updateName({
      constraints: changes.constraints,
      errors: payload.errors,
      name: payload.name,
      constraintsPending: false })
  }

  if (typeof payload.tags !== 'undefined') {
    return updateTags({
      constraints: changes.constraints,
      errors: payload.errors,
      tags: payload.tags,
      constraintsPending: false })
  }
  return updateConstraints({ constraints: changes.constraints })
}

const getConstraintsForTerms = (params) => {
  const defaultResponse = { terms: [] }

  if (!params.length) {
    return defaultResponse
  }

  const url = new URL(gon.constraints_url)
  const terms = Array.from(new Set(params))
  url.searchParams.append('terms', terms)

  const options = {
    method: 'GET',
    credentials: 'same-origin',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }

  return fetch(url, options).then((response) => response.json()).catch((_) => defaultResponse)
}

const getFormState = (state) => (
  state.formState
)

const sanitizedArrayFrom = ({ description, name, tags }) => (
  [].concat(...[name, tags, stripHTMLFromString(description)].map(
    (term) => term && filterTokens(tokenize(term))
  ))
)

const formValuesFrom = (formState = {}) => (
  (formState.turbosquid_product_form || {}).values || {}
)

const injectExceptionChanges = (changes, e) => {
  const payload = changes.payload || {}
  const errors = [...(payload.errors || []), e.message]
  const fieldName = ['name', 'tags', 'description'].find((key) => payload[key] !== undefined)

  return {
    ...(fieldName ? { fieldName, fieldValue: payload[fieldName] } : {}),
    ...(payload.features !== undefined ? { features: payload.features } : {}),
    ...(payload.draftSavePendingChanges !== undefined
      ? { draftSavePendingChanges: payload.draftSavePendingChanges }
      : {}),
    errors,
  }
}

function* findConstraints(oldState, newState) {
  const newTerms = sanitizedArrayFrom(formValuesFrom(newState))
  const oldTerms = sanitizedArrayFrom(formValuesFrom(oldState))
  const addedTerms = newTerms.filter((term) => term.length > 0 && !oldTerms.includes(term))

  const constraints = (oldState.constraints || []).filter(
    (constraint) => newTerms.includes(constraint.term)
  )

  // TSQ-25013: Disconnect banned/editorial word check in OPP for now
  /*
  if (addedTerms.length) {
    const response = yield call(getConstraintsForTerms, addedTerms)
    constraints = constraints.concat(response.terms)
  }
  */

  return constraints
}

export function* fetchConstraintsFromServer(params = {}) {
  const changes = { ...params }
  try {
    const oldState = yield select(getFormState)
    let useState = {}
    if (!Object.keys(changes.payload).includes('name') && !Object.keys(changes.payload).includes('description')) {
      useState = oldState
    }
    const updatedValues = { ...oldState.turbosquid_product_form.values, ...changes.payload }

    const newState = { ...oldState, turbosquid_product_form: { values: updatedValues } }

    changes.constraints = yield findConstraints(useState, newState)
    yield put(constraintsFetchSucceeded(changes))
  } catch (e) {
    const newChanges = injectExceptionChanges(changes, e)
    yield put(constraintsFetchFailed(newChanges))
  }
}

export function* fetchInitialConstraintsFromServerSaga() {
  try {
    const oldState = {}
    const newState = yield select(getFormState)
    const constraints = yield findConstraints(oldState, newState)

    yield put(constraintsFetchSucceeded({ constraints }))
  } catch (e) {
    yield put(constraintsFetchFailed({ error: e.message }))
  }
}
